import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Field, FieldProps, useField } from 'formik';
import classNames from 'classnames';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';

import TextField from 'hellospa/foundation/control/text-field';
import ErrorMessage from 'hellospa/components/error-message';
import styles from './index.scss';
import messages from './intl';

type Props = {
  index: number,
};

const Role = ({ index }: Props) => {
  const intl = useIntl();
  const showInlinePreview = useSelector(selectors.showInlinePreview);

  const parent = `recipients.${index}`;

  const [, meta] = useField<String>(`${parent}.name`);

  return (
    <div
      className={styles.fields}
      data-qa-ref={`${parent}.fields`}
    >
      <div
        className={classNames(styles.fieldRow, {
          [styles.fullWidthFieldRow]: showInlinePreview,
        })}
      >
        <div
          className={classNames({
            [styles.errorFieldContainer]: meta.touched && meta.error,
          })}
        >
          <label htmlFor={`${parent}.name`}>
            {intl.formatMessage(messages.fieldRoleLabel)}
          </label>
          <Field
            name={`${parent}.name`}
          >
            {({ field }: FieldProps) => <TextField
              id={`${parent}.name`}
              autoFocus={index === 0}
              data-qa-ref={`${parent}.fields.name`}
              placeholder={intl.formatMessage(messages.fieldRolePlaceholder)}
              {...field} />}
          </Field>
          <div
            className={styles.errorContainer}
            role="name-error"
            data-qa-ref={`${parent}.errors.name`}
          >
            <ErrorMessage
              name={`${parent}.name`}
              className={styles.error} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Role;
